import { CouponListApiData, ServiceOrganizationCouponListApiData } from '@navio/nsdk';
import { SharedQuery, filterUnitFor, useFilterUnits } from 'noddi-ui-web';
import { useUserGroupOptions } from '../UserGroup/useUserGroupFilter';
import { COUPON_SOURCE_FILTER_OPTIONS } from './useCouponSourceFilter';

// One unit set feeds whichever endpoint the list calls: all coupons or one service organization's.
type CouponListFilterInput = Omit<
  SharedQuery<NonNullable<CouponListApiData['query']>, NonNullable<ServiceOrganizationCouponListApiData['query']>>,
  'pageIndex' | 'pageSize' | 'ordering' | 'search' | 'serviceOrganizationId'
>;

const couponFilterUnit = filterUnitFor<CouponListFilterInput>();

export const useCouponTableFilters = ({
  serviceOrganizationIds,
  brandIds
}: {
  /** Scopes the customer options. */
  serviceOrganizationIds?: number[];
  /** Brands the list is locked to. */
  brandIds?: number[];
} = {}) => {
  const customers = useUserGroupOptions({ serviceOrganizationIds });

  return useFilterUnits([
    couponFilterUnit.locked({ brandIds }),
    couponFilterUnit.multiSelect('userGroupIds', {
      title: 'Customer',
      description: 'Filter by customer',
      source: customers,
      defaultVisibleOptions: 3,
      exclude: true
    }),
    couponFilterUnit.multiSelect('sources', {
      title: 'Source',
      description: 'Filter by how the coupon was issued',
      options: COUPON_SOURCE_FILTER_OPTIONS,
      defaultVisibleOptions: 3,
      exclude: true
    }),
    couponFilterUnit.boolean('isExhausted', { title: 'Used', description: 'Only show used or unused coupons' }),
    couponFilterUnit.boolean('isExpired', {
      title: 'Expired',
      description: 'Only show expired or not-yet-expired coupons'
    }),
    couponFilterUnit.dateRange('expiresAt', {
      title: 'Expires',
      description: 'Filter by expiry date range',
      exclude: true
    }),
    couponFilterUnit.dateRange('usedAt', {
      title: 'Used at',
      description: 'Filter by when the coupon was used',
      exclude: true
    }),
    couponFilterUnit.dateRange('createdAt', {
      title: 'Created at',
      description: 'Filter by creation date range',
      exclude: true
    })
  ]);
};
